import { render, staticRenderFns } from "./Promociones.vue?vue&type=template&id=22cc1777&scoped=true"
import script from "./Promociones.vue?vue&type=script&lang=js"
export * from "./Promociones.vue?vue&type=script&lang=js"
import style0 from "./Promociones.vue?vue&type=style&index=0&id=22cc1777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc1777",
  null
  
)

export default component.exports